import styled, { css } from 'styled-components';

import media from '~/utils/media';
import checkboxStd from '~/components/styled/checkbox';

const layoutStd = css`
  position: relative;
`;

export const Wrap = styled.div`
  ${layoutStd};

  > #stamp {
    width: 100%;
    height: 50%;
    object-fit: contain;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const RelativeWrap = styled.div`
  ${layoutStd};

  > img#check {
    width: 95%;
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  > button {
    width: 60%;
    height: 50px;
    border: 0;
    background: transparent;
    position: absolute;
    left: 50%;
    bottom: 3%;
    transform: translateX(-50%);
  }
`;

export const AgreeWrap = styled.div`
  padding: 4%;
  background-color: #051628;
`;

export const LabelWrap = styled.div`
  & + & {
    margin-top: 4%;
  }
`;

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  width: 100%;
  
  ${media.pcLarge`
    font-size: 20px;
  `}

  ${media.tabletLarge`
    font-size: 20px;
  `}

  ${media.tabletSmall`
    font-size: 20px;
  `}

  ${media.mobileLarge`
    font-size: 14px;
  `}

  ${media.mobileMid`
    font-size: 14px;
  `}

  ${media.mobileSmall`
    font-size: 14px;
  `}

  font-weight: 700;
  color: #FFFFFF;
  letter-spacing: -1px;

  > svg {
    margin-left: 2%;

    ${({ isCheck }) => isCheck ? css`
      transform: rotate(-180deg);
      transition: transform 150ms ease;
    ` : css`
      transform: rotate(0deg);
      transition: transform 150ms ease;
    `}

    ${media.mobileSmall`
      width: 32px;
      height: 32px;
    `}

    ${media.pcLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletSmall`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileLarge`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileMid`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileSmall`
      width: 20px;
      height: 20px;
    `}
  }
`;

export const Checkbox = styled.input`
  ${checkboxStd};

  ${media.mobileSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.pcLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.mobileLarge`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileMid`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileSmall`
    width: 20px;
    height: 20px;
  `}

  margin-right: 2%;
`;

export const Ul = styled.ul`
  margin-top: 2%;

  > li {
    padding-left: 2%;

    ${media.pcLarge`
      font-size: 16px;
    `}

    ${media.tabletLarge`
      font-size: 16px;
    `}

    ${media.tabletSmall`
      font-size: 16px;
    `}

    ${media.mobileLarge`
      font-size: 10px;
    `}

    ${media.mobileMid`
      font-size: 10px;
    `}

    ${media.mobileSmall`
      font-size: 10px;
    `}

    ${media.pcLarge`
      line-height: 28px;
    `}

    ${media.tabletLarge`
      line-height: 28px;
    `}

    ${media.tabletSmall`
      line-height: 28px;
    `}

    ${media.mobileLarge`
      line-height: 20px;
    `}

    ${media.mobileMid`
      line-height: 20px;
    `}

    ${media.mobileSmall`
      line-height: 20px;
    `}

    color: #FFFFFF;
    letter-spacing: -1px;
  }
`;
